import Vue from "vue";
import Vuelidate from "vuelidate";

// for bootstap form validate
Vue.use(Vuelidate);
